// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17T2O","comment":"styles_comment__2baWe"};